import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar , ChevronLeft, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import slide1 from "../../assets/images/Home/slide1.jpg"
import slide2 from "../../assets/images/Home/slide2.jpeg"
import slide3 from "../../assets/images/Home/slide3.jpg"

const Slider = () => {
  const slides = [
    {
      id: 1,
      image: slide1,
      title: "COMPASSIONATE",
      sub: "CARE",
      desc: "Leading the way in Women's Health with Dr. Vibha's dedicated approach.",
    },
    {
      id: 2,
      image:slide2,
      title: "TRUSTED",
      sub: "FERTILITY CARE",
      desc: "Advanced technology meets human empathy on your journey.",
    },
    {
      id: 3,
      image: slide3,
      title: "EXPERT",
      sub: "GYNAE",
      desc: "Comprehensive care tailored to every stage of your life.",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () =>
    setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  const prevSlide = () =>
    setCurrent((prev) => (prev === 0 ? slides.length - 1 : prev - 1));

  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      {/* --- LAYER 1: BACKGROUND IMAGES (Cross-fade logic) --- */}
      <div className="absolute inset-0 z-0">
        <AnimatePresence mode="wait">
          <motion.img
            key={slides[current].id} // ID use karna sabse safe hai unique key ke liye
            src={slides[current].image}
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2, ease: "easeInOut" }}
            className="absolute inset-0 w-full h-full object-cover"
            alt="background"
          />
        </AnimatePresence>
      </div>

      {/* --- LAYER 2: DARK OVERLAY & CONTENT --- */}
      <div className="relative z-10 w-full h-full flex items-center">
        {/* Dark Gradient Overlay: Yeh image ke upar blend hota hai */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/50 to-transparent"></div>

        <div className="relative z-20 px-8 lg:px-24 w-full lg:w-1/2">
          {/* Text Animation */}
          <AnimatePresence mode="wait">
            <motion.div
              key={current}
              initial={{ y: 30, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -30, opacity: 0 }}
              transition={{ duration: 0.8 }}
            >
              <span className="text-[#b76e79] text-xs font-bold uppercase tracking-[0.5em] mb-4 block">
                Welcome to Health
              </span>
              <h1 className="text-6xl lg:text-[100px] font-bold leading-[0.9] mb-8 text-white">
                {slides[current].title} <br />
                <span
                  className="text-transparent"
                  style={{ WebkitTextStroke: "2px white", opacity: 0.6 }}
                >
                  {slides[current].sub}
                </span>
              </h1>
              <p className="text-gray-300 text-lg max-w-md mb-10 leading-relaxed">
                {slides[current].desc}
              </p>

              <div className="flex flex-wrap gap-6">
                <Link to="/contact-us">
                  <button className="bg-[#b76e79] text-white px-10 py-5 rounded-xl font-bold tracking-widest text-xs flex items-center gap-3 hover:bg-white hover:text-black transition-all shadow-2xl">
                    <Calendar size={16} /> APPOINTMENT
                  </button>
                </Link>
{/* 
                <Link to="/contact-us">
                  <button className="border-b-2 border-white/50 text-white px-2 py-5 font-bold tracking-widest text-xs flex items-center gap-3 hover:border-white transition-all">
                    OUR SERVICES <ArrowRight size={16} />
                  </button>
                </Link> */}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      {/* --- LAYER 3: CONTROLS (Z-index high rakha hai) --- */}
      <div className="absolute bottom-10 right-10 z-50 flex gap-4">
        <button
          onClick={prevSlide}
          className="p-3 border border-white/20 rounded-full text-white hover:bg-white hover:text-black transition-all active:scale-95"
        >
          <ChevronLeft size={24} />
        </button>
        <button
          onClick={nextSlide}
          className="p-3 border border-white/20 rounded-full text-white hover:bg-white hover:text-black transition-all active:scale-95"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      {/* Progress Indicator */}
      <div className="absolute left-10 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col items-center gap-6">
        <div className="h-32 w-[1px] bg-white/20 relative">
          <motion.div
            key={current}
            className="absolute top-0 left-0 w-full bg-[#b76e79]"
            initial={{ height: 0 }}
            animate={{ height: "100%" }}
            transition={{ duration: 5, ease: "linear" }}
          />
        </div>
        <span className="text-white font-bold text-3xl -rotate-90 tracking-tighter">
          0{current + 1}
        </span>
      </div>
    </div>
  );
};

export default Slider;
